import { Menu, MenuDivider, MenuItem } from "@blueprintjs/core";
import { signOut, useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { useDialogManager } from "../global/dialog";
import { useCallback } from "react";
import UserProfileDialog from "../user/userprofiledialog";

export default function LoggedInMenu(): JSX.Element {
    const router = useRouter();
    const { addDialog } = useDialogManager();
    const { data: session } = useSession();
    const userId = session.user.id;

    const viewProfile = useCallback(
        () => {
            addDialog(
                <UserProfileDialog
                    isOpen={true}
                    userId={userId}
                    onClose={() => {}}
                />,
            );
        },
        [addDialog, userId],
    );

    return <Menu>
        <MenuItem
            text='Edit Profile'
            onClick={() => router.push('/user/editprofile')}
        />
        <MenuItem
            text='View Profile'
            onClick={viewProfile}
        />
        <MenuDivider />
        <MenuItem
            text='Sign Out'
            onClick={() => signOut()}
        />
    </Menu>;
}
